module.exports = __webpack_public_path__ + "img/1.66605e39.jpg";